import "./index.css";
import avatar from "./assets/person-circle.svg";
import logout from "./assets/box-arrow-right.svg";
// import gear from "./assets/gear-wide-connected.svg";
import home from "./assets/house-fill.svg";
import brand from "./assets/log-menu.png";
import grades from "./assets/mortarboard-fill.svg";
import msg from "./assets/chat-dots-fill.svg";
import resume from "./assets/collection-play-fill.svg";
import DarkModeIcon from "@mui/icons-material/DarkMode";
import LightModeIcon from "@mui/icons-material/LightMode";

import { Link, useNavigate } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { useAuth } from "../../contexts/AuthContext";
import { useMoodle } from "../../contexts/MoodleContext";
import { CustomDialog } from "../Dialog";
import { useMoodleV2 } from "../../contexts/moodle";
import { Drawer } from "@mui/material";
import { useTheme } from "../../contexts/ThemeContext";
import { useConfig } from "../../contexts/config";
import { readableColor } from "polished";

export const Sidebar = ({ isOpen, onClose }) => {
  const [openDialog, setOpenDialog] = useState(false);
  const [contrastColor, setContrastColor] = useState("#fff");
  const [course, setCourse] = useState(null);
  const { lang } = useAuth();
  const moodle = useMoodle();
  const auth = useAuth();
  const moodlev2 = useMoodleV2();
  const theme = useTheme();
  const config = useConfig();
  const navigate = useNavigate();

  const handleDarkMode = () => {
    theme.actions.handleDarkMode();
  };

  const handleLogoutCompleted = () => {
    setOpenDialog(false);
    auth.logout(moodlev2);
    navigate("/");
  };

  const handleLogout = () => {
    setOpenDialog(true);
  };

  useEffect(() => {
    if (theme && theme.colors) {
      setContrastColor(readableColor(theme.colors.backgroundColorNavBar));
    }
  }, [theme]);

  useEffect(() => {
    if (moodle.currentCourse) {
      setCourse(moodle.currentCourse);
    }
  }, [moodle.currentCourse]);

  return (
    <>
      {lang && (
        <Drawer open={isOpen} onClose={onClose}>
          <div
            className="flex h-full flex-col text-white w-[320px]"
            style={{backgroundColor:theme.colors && theme.colors.backgroundColorNavBar}}
          >
            <div className="flex items-center justify-between p-4 gap-4">
              <div className="flex items-center gap-4">
                {/* <img src={gear} alt="Settings" className="size-8" /> */}
                <img
                  src={auth.user?.profileimageurlsmall || avatar}
                  alt="Avatar"
                  className="size-20 rounded-full"
                />
                <p
                  className="text-2xl font-semibold line-clamp-2"
                  style={{ color: contrastColor }}
                >
                  {auth.user?.fullname || "Estudiante"}
                </p>
              </div>
              <img
                src={logout}
                className="size-8"
                alt="..."
                onClick={handleLogout}
              />
            </div>

            <div className="flex-1 px-2 py-4">
              <ul className="flex flex-col gap-4">
                <Link
                  to="/listcourses"
                  onClick={onClose}
                  className="flex items-center gap-4 p-3 rounded-md"
                >
                  <img src={home} alt="Home" className="size-8" />
                  <span
                    className="font-medium"
                    style={{ color: contrastColor }}
                  >
                    {lang?.Navbar?.home || "Inicio"}
                  </span>
                </Link>
                <Link
                  to="/listcourses/progress"
                  onClick={onClose}
                  className="flex items-center gap-4 p-3 rounded-md"
                >
                  <img src={grades} alt="Grades" className="w-6 h-6" />
                  <span
                    className="font-medium"
                    style={{ color: contrastColor }}
                  >
                    {lang?.Navbar?.history || "Historial"}
                  </span>
                </Link>
                {/* {config.opciones.includes("contacto") && (
                  <Link
                    to="/contact"
                    onClick={onClose}
                    className="flex items-center gap-4 p-3 rounded-md"
                  >
                    <img src={msg} alt="Messages" className="w-6 h-6" />
                    <span
                      className="font-medium"
                      style={{ color: contrastColor }}
                    >
                      {lang?.Navbar?.contact || "Contacto"}
                    </span>
                  </Link>
                )} */}
                {course && (
                  <Link
                    to="/contact"
                    onClick={onClose}
                    className="flex items-center gap-4 p-3 rounded-md bg-gray-100 hover:bg-blue-100 transition-all"
                  >
                    <img src={resume} alt="Resume" className="w-6 h-6" />
                    <span className="text-gray-800 font-medium">
                      Continuar con {course.shortname}
                    </span>
                  </Link>
                )}
              </ul>
            </div>

            <div className="p-4 flex justify-around">
              <img
                src={config.config.config.theme && (theme && theme.mode === "light" ? config.config.config.theme.logo : config.config.config.theme.theme_logo_dark)}
                alt="Logo"
                className="w-52 h-[auto]"
              />
              <div
                className="rounded-[50%] p-[7px] flex items-center text-white cursor-pointer"
                onClick={handleDarkMode}
                style={{
                  backgroundColor: theme.mode === "light" ? "#f5f5f5" : "#333",
                }}
              >
                {theme.mode === "light" ? (
                  <LightModeIcon
                    sx={{ fontSize: 22, fill: "#333" }}
                    style={{ fill: "#333" }}
                  />
                ) : (
                  <DarkModeIcon sx={{ fontSize: 22 }} />
                )}
              </div>
            </div>
          </div>

          <CustomDialog
            open={openDialog}
            message={
              lang?.Snackbars?.acc_logout_message ||
              "¿Estás seguro de que deseas cerrar sesión?"
            }
            confirm={lang?.Snackbars?.confirm || "Confirmar"}
            cancel={lang?.Snackbars?.cancel || "Cancelar"}
            onCancel={() => setOpenDialog(false)}
            onConfirm={handleLogoutCompleted}
          />
        </Drawer>
      )}

      {/* {lang && (
        <div className="sidebar-container">
          <div className="top">
            <div className="top-content">
              <img src={gear} alt="..." />
              <img src={avatar} className="avatar" alt="..." />
              <img src={logout} alt="..." onClick={handleLogout} />
            </div>
          </div>
          <div className="center">
            <div className="center-content">
              <ul>
                <Link to={"/listcourses"} onClick={handleSidebar}>
                  <li>
                    <img src={home} alt="..." />
                    {lang["Navbar"].home}
                  </li>
                </Link>
                <Link to={"/listcourses/progress"} onClick={handleSidebar}>
                  <li>
                    {" "}
                    <img src={grades} alt="..." />
                    {lang["Navbar"].history}
                  </li>
                </Link>
                <Link to={"/contact"} onClick={handleSidebar}>
                  <li>
                    {" "}
                    <img src={msg} alt="..." />
                    {lang["Navbar"].contact}
                  </li>
                </Link>
                {course && (
                  <Link to={"/contact"} onClick={handleSidebar}>
                    <li>
                      {" "}
                      <img src={resume} alt="..." />
                      Continuar con {course.shortname}
                    </li>
                  </Link>
                )}
              </ul>
            </div>
          </div>
          <div className="bottom">
          
            <div>
              <img src={brand} alt="..." />
            </div>
          </div>
          <CustomDialog
            open={openDialog}
            message={lang["Snackbars"].acc_logout_message}
            confirm={lang["Snackbars"].confirm}
            cancel={lang["Snackbars"].cancel}
            onCancel={() => setOpenDialog(false)}
            onConfirm={handleLogoutCompleted}
          />
        </div>
      )}  */}
    </>
  );
};
